import { ref, onMounted, onUnmounted } from 'vue';

export function useDeviceType() {
  const deviceType = ref('desktop');

  const updateDeviceType = () => {
    if (window.matchMedia('(max-width: 767px)').matches) {
      deviceType.value = 'mobile';
    } else if (window.matchMedia('(min-width: 768px) and (max-width: 1024px)').matches) {
      deviceType.value = 'tablet';
    } else {
      deviceType.value = 'desktop';
    }
  };

  onMounted(() => {
    updateDeviceType();
    window.addEventListener('resize', updateDeviceType);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', updateDeviceType);
  });

  return {
    deviceType,
  };
}
